module.exports = __webpack_public_path__ + "img/nbz-coin.ad83acda.svg";